export const PHONE = "0575640550";
export const PHONE_INTL = "+966575640550";
export const WHATSAPP_URL = `https://wa.me/966575640550`;
export const BRAND = "الخيط الذهبي";
export const BRAND_LATIN = "Golden Thread";
export const CITY = "خميس مشيط";

export const services = [
    {
        id: "crystal",
        title: "تلميع الرخام بالكريستال",
        short: "لمعان يفوق المرآة بتقنية الكريستال البلوري",
        desc: "خدمة تلميع الرخام بالكريستال تمنح أرضياتك لمعاناً استثنائياً ومقاومة عالية للخدوش والبقع، عبر تفاعل كيميائي دقيق بين مسحوق الكريستال وسطح الرخام تحت ضغط حراري محكم.",
        icon: "gem",
        image: "/gallery/marble-white-livingroom.jpg",
        features: ["لمعان يدوم لسنوات", "مقاومة الخدوش", "تعبئة المسامات", "بدون روائح كيميائية"],
    },
    {
        id: "stairs",
        title: "جلي وتلميع درج الرخام",
        short: "استعادة رونق درج الرخام مهما كان عمره",
        desc: "متخصصون في جلي وتلميع درج الرخام لجميع الفلل والعمائر بخميس مشيط، نستخدم معدات ألمانية دقيقة لإزالة الطبقات المتضررة وإعادة اللمعان الأصلي دون خدش الحواف.",
        icon: "stairs",
        image: "/gallery/marble-colored-border.jpg",
        features: ["إزالة الطبقات التالفة", "توحيد اللون", "حماية الحواف", "تلميع نهائي فاخر"],
    },
    {
        id: "facades",
        title: "جلي واجهات الحجر والرخام",
        short: "واجهات فخمة تعكس هوية مبناك",
        desc: "نقدم خدمة جلي واجهات الحجر والرخام للمنازل والمباني التجارية، بأحدث ماكينات الجلي الرأسية للوصول لأصعب الأماكن مع ضمان النظافة وسلامة المبنى.",
        icon: "building",
        image: "/gallery/marble-outdoor-palace.jpg",
        features: ["معدات ارتفاعات آمنة", "تنظيف بعد الجلي", "مقاومة العوامل الجوية", "فنيون معتمدون"],
    },
    {
        id: "isolation",
        title: "عزل الرخام",
        short: "حماية طويلة الأمد ضد الرطوبة والبقع",
        desc: "عزل الرخام بمواد نانو متطورة تخترق مسامات الحجر لتحميه من امتصاص الماء والزيوت والبقع، مع الحفاظ على مظهره الطبيعي دون تغيير في اللمعان.",
        icon: "shield",
        image: "/gallery/marble-emperador-hall.jpg",
        features: ["تقنية النانو", "مقاومة الماء والزيت", "ضمان يصل إلى 5 سنوات", "لا يغير اللون"],
    },
    {
        id: "floors",
        title: "تلميع أرضيات الرخام",
        short: "أرضيات كالمرآة تعكس فخامة مساحتك",
        desc: "خدمة تلميع أرضيات الرخام بجميع أنواعه (كرارا، بوتيتشينو، إمبرادور، عماني) بمراحل جلي متدرجة من الخشن للناعم للحصول على لمعان مثالي وسطح مستوٍ تماماً.",
        icon: "sparkles",
        image: "/gallery/marble-chandelier.jpg",
        features: ["6 مراحل جلي", "تسوية كاملة", "لمعان فائق", "خدمة على مدار الأسبوع"],
    },
    {
        id: "restoration",
        title: "ترميم وإصلاح الرخام",
        short: "إصلاح الشروخ والبقع كأنها لم تكن",
        desc: "نصلح الشروخ والكسور والبقع العميقة في الرخام باستخدام حشوات إيبوكسي مطابقة للون الأصلي، مع تلميع نهائي يعيد للسطح تجانسه الكامل.",
        icon: "wrench",
        image: "/gallery/marble-brown-shine.jpg",
        features: ["إصلاح الشروخ", "معالجة البقع الغائرة", "تطابق اللون", "ضمان جودة"],
    },
];

export const stats = [
    { value: "12+", label: "سنة خبرة" },
    { value: "3200+", label: "عميل راضٍ" },
    { value: "850k", label: "متر² منجز" },
    { value: "24/7", label: "خدمة عملاء" },
];

export const testimonials = [
    {
        name: "أحمد الشهري",
        role: "مالك فيلا - خميس مشيط",
        text: "خدمة راقية جداً، لمعان الرخام تغير 180 درجة والفريق محترم ومنظم. ننصح فيهم بشدة.",
    },
    {
        name: "منال العسيري",
        role: "مقاول ديكور",
        text: "أعتمد عليهم في كل مشاريعي، دقة في المواعيد وجودة تشطيب راقية بأسعار منافسة.",
    },
    {
        name: "سعود القحطاني",
        role: "مدير مجمع تجاري",
        text: "جلوا لنا واجهة المجمع وأرضيات الاستقبال، النتيجة فوق التوقعات وشغلهم نظيف بدون ضجيج.",
    },
];

export const keywords = [
    "جلي الرخام خميس مشيط", "تلميع الرخام خميس مشيط", "شركة جلي رخام أبها", "تلميع رخام بالكريستال",
    "جلي درج رخام", "تلميع درج الرخام", "جلي واجهات حجر", "تلميع واجهات الرخام", "عزل الرخام",
    "عزل رخام النانو", "تلميع أرضيات الرخام", "شركة تلميع رخام", "أفضل شركة جلي رخام",
    "جلي رخام كرارا", "تلميع بوتيتشينو", "جلي رخام إمبرادور", "جلي رخام عماني", "ترميم الرخام",
    "إصلاح شروخ الرخام", "تلميع رخام فلل", "تلميع رخام قصور", "جلي رخام مجمعات تجارية",
    "جلي رخام فنادق", "شركة رخام خميس مشيط", "فني جلي رخام", "جلي رخام أسعار",
    "تلميع رخام بأسعار مناسبة", "جلي رخام مضمون", "تلميع رخام محترف", "جلي أرضيات",
    "جلي حجر", "تلميع حجر طبيعي", "تلميع جرانيت", "جلي جرانيت", "تلميع ارضيات جرانيت",
    "خدمات الرخام عسير", "شركة رخام أبها", "جلي رخام النماص", "جلي رخام محايل",
    "جلي رخام بيشة", "جلي رخام سراة عبيدة", "معلم جلي رخام", "فني تلميع", "شركة تنظيف رخام",
    "شركة صيانة رخام", "شركة عزل رخام", "مؤسسة جلي وتلميع", "جلي رخام بضمان",
    "أرقام شركات جلي الرخام", "جلي الرخام بالسعودية", "لمعان الرخام", "الرخام اللامع",
];
